function safeDecodeUriComponent(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

/** Public URL segment: `MANUFACTURING_AND_INDUSTRIAL_AUTOMATION` → `manufacturing-and-industrial-automation`. */
export function operatingIndustryToUrlSlug(industry: string): string {
  const trimmed = industry.trim();
  if (!trimmed) return "";
  return encodeURIComponent(trimmed.toLowerCase().replace(/_/g, "-"));
}

/**
 * Route param → Prisma `OperatingIndustry` enum.
 * Accepts hyphen slugs and legacy uppercase (or mixed-case) enum values.
 */
export function operatingIndustryFromUrlSlug(param: string): string {
  const decoded = safeDecodeUriComponent(param).trim();
  if (!decoded) return "";
  if (decoded.includes("-")) {
    return decoded.toUpperCase().replace(/-/g, "_");
  }
  return decoded.toUpperCase();
}

/** Returns a pathname with the industry segment slugged, or null if already canonical / unmatched. */
export function pathnameWithCanonicalIndustrySlug(pathname: string, industryParam: string): string | null {
  const enumValue = operatingIndustryFromUrlSlug(industryParam);
  if (!enumValue) return null;
  const canonicalSeg = operatingIndustryToUrlSlug(enumValue);
  const canonicalDecoded = safeDecodeUriComponent(canonicalSeg);

  let replaced = false;
  const next = pathname.split("/").map((part) => {
    if (!part) return part;
    const decoded = safeDecodeUriComponent(part);
    if (operatingIndustryFromUrlSlug(decoded) !== enumValue) return part;
    if (decoded === canonicalDecoded) return part;
    replaced = true;
    return canonicalSeg;
  });
  return replaced ? next.join("/") : null;
}
